import { motion } from 'framer-motion';

const NUMBER = '917418042004';
const MESSAGE = encodeURIComponent(
  'Hello EQUINOX SPICES, I would like to enquire about turmeric / cardamom supply.'
);

function WhatsAppIcon({ className }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
      <path d="M16 3C8.8 3 3 8.7 3 15.8c0 2.5.7 4.9 2 7L3 29l6.4-1.9c2 1.1 4.3 1.7 6.6 1.7 7.2 0 13-5.7 13-12.8S23.2 3 16 3zm0 23.4c-2.1 0-4.1-.6-5.8-1.6l-.4-.2-3.8 1.1 1.1-3.6-.3-.4a10.3 10.3 0 0 1-1.7-5.9C5.1 10 10 5.2 16 5.2s10.9 4.8 10.9 10.6S22 26.4 16 26.4zm6-7.9c-.3-.2-1.9-1-2.2-1.1-.3-.1-.5-.2-.7.2-.2.3-.8 1.1-1 1.3-.2.2-.4.2-.7.1-.3-.2-1.4-.5-2.6-1.6-1-.9-1.6-1.9-1.8-2.2-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6l-1-2.4c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.3 1.4 3.5c.2.2 2.4 3.6 5.8 5 .8.4 1.4.6 1.9.7.8.3 1.5.2 2.1.1.6-.1 1.9-.8 2.2-1.5.3-.8.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z" />
    </svg>
  );
}

export default function WhatsAppButton() {
  return (
    <motion.a
      href={`https://wa.me/${NUMBER}?text=${MESSAGE}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Message for enquiries on WhatsApp"
      data-testid="whatsapp-button"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.2, duration: 0.6, ease: 'easeOut' }}
      className="group fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-full border border-white/10 bg-coal/80 pl-2 pr-5 py-2 text-bone shadow-[0_12px_40px_rgba(0,0,0,0.45)] backdrop-blur-md transition-colors duration-300 hover:border-turmeric/60 md:bottom-8 md:right-8"
    >
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#25D366] text-night transition-transform duration-300 group-hover:scale-110">
        <WhatsAppIcon className="h-5 w-5" />
      </span>
      <span className="hidden flex-col leading-tight sm:flex">
        <span className="text-[10px] uppercase tracking-[0.24em] text-dune">WhatsApp</span>
        <span className="text-[13px] font-medium text-bone">Message for enquiries</span>
      </span>
    </motion.a>
  );
}
